import(/* webpackMode: "eager" */ "C:\\website\\src\\app\\loading.tsx");
